export const getToken = state => state.auth.token;
export const getUser = state => state.auth.user;
export const getIsAuthenticated = state => state.auth.isAuthenticated;
